module.exports = __webpack_public_path__ + "img/咖啡豆@2x.d14c4c64.png";